import {
  initArticleVideos,
  initArticleCarousel,
} from './article-newsroom-content/article-newsroom';

import { initBackLink } from '../../snippets/article-back-link/article-back-link';

initBackLink();
initArticleVideos();
initArticleCarousel();
